import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    MEMBERS: "اعضای هیئت علمی",
    GRADE: "مرتبه علمی",
    GROUP: "گروه",
    EXPERTATION: "تخصص",
    POSITION: "سمت",
    GRADUATED: "فارغ التحصیل رشته",
    EMAIL: "ایمیل",
    PHONE: "تلفن",
    NO_OPTIONS: "موردی یافت نشد",
    FIELDS: {
      FULL_NAME: { LABEL: "نام و نام خانوادگی" },
      COLLEGES: { LABEL: "دانشکده‌ها", PLACEHOLDER: "انتخاب کنید" },
      GROUPS: { LABEL: "گروه‌های آموزشی", PLACEHOLDER: "انتخاب کنید" },
    },
  },
  [LOCALES.EN]: {
    MEMBERS: "Members",
    GRADE: "Grade",
    GROUP: "Group",
    EXPERTATION: "Expertation",
    POSITION: "Position",
    GRADUATED: "Graduated",
    EMAIL: "Email",
    PHONE: "Phone",
    NO_OPTIONS: "No Options",
    FIELDS: {
      FULL_NAME: { LABEL: "Full Name" },
      COLLEGES: { LABEL: "Colleges", PLACEHOLDER: "Select" },
      GROUPS: { LABEL: "Groups", PLACEHOLDER: "Select" },
    },
  },
} as const;

export default translation;
